import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import AboutActions from "./AboutActions";
import { hotLoadObject } from "data/storeUtils";
import dotProp from "dot-prop-immutable";
import LoadObject from "data/LoadObject";
import DataManager from "data/DataManager";
import version from "version";
import typeCheckingStore from "data/util/typeCheckingStore";

const AGGREGATE_MODULE = "hybrid-accsts-version";

function mungeApiIntoApp(app, api) {
    const parts = app.split(":");
    app = parts[2];
    parts[2] = app.indexOf("-SNAPSHOT") < 0
        ? app // only snapshot versions can care
        : app + "." + (api || 0);
    return parts.join(":");
}

class AboutStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return {
            clientVersion: version.client,
            requiredApiVersion: version.requiredApiVersion,
        };
    }

    reduce(state, action) {
        switch (action.type) {
            case AboutActions.START_LOAD_VERSION_INFO:
                return dotProp.set(state, ["apiVersion"], LoadObject.empty().withPropTypes(
                    {
                        application: PropTypes.string.isRequired,
                        aggregate: PropTypes.string,
                        meta: PropTypes.arrayOf(
                            PropTypes.shape({
                                key: PropTypes.string.isRequired,
                                version: PropTypes.string.isRequired,
                            })
                        ),
                        modules: PropTypes.arrayOf(
                            PropTypes.string
                        ),
                    },
                    "AboutStore",
                ).loading(
                    DataManager.loadVersionInfo()
                ));
            case AboutActions.LOADED_VERSION_INFO:
                return dotProp.set(state, ["apiVersion"], lo => lo.receiveValue({
                    ...action.data,
                    application: mungeApiIntoApp(
                        action.data.application,
                        action.data.api
                    ),
                    aggregate: action.data.modules.find(it =>
                        it.split(":")[1] === AGGREGATE_MODULE
                    ),
                }));
            case AboutActions.LOAD_VERSION_INFO_ERROR:
                return dotProp.set(state, ["apiVersion"], lo => lo.receiveError(action.error));
            default:
                return state;
        }
    }

    getClientVersion() {
        return this.getState().clientVersion;
    }

    getRequiredApiVersion() {
        return this.getState().requiredApiVersion;
    }

    getApiVersion() {
        return this.getApiVersionLO().getRequiredValue();
    }

    getApiVersionLO() {
        return hotLoadObject(
            () => this.getState().apiVersion,
            () => Dispatcher.dispatch({
                type: AboutActions.START_LOAD_VERSION_INFO,
            }),
        );
    }
}

AboutStore.stateTypes = {
    clientVersion: PropTypes.string.isRequired,
    requiredApiVersion: PropTypes.string.isRequired,
    apiVersion: PropTypes.instanceOf(LoadObject),
};

export default typeCheckingStore(new AboutStore());



// WEBPACK FOOTER //
// ./app/data/meta/AboutStore.js